"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.LrsClient = exports.getNetworkLayers = exports.getAllLayers = exports.getLrsServiceInfo = exports.validateUrl = void 0;
const urlRe = __importStar(require("./urlRe"));
const arcgis_rest_request_1 = require("@esri/arcgis-rest-request");
const UrlFormatError_1 = __importDefault(require("./UrlFormatError"));
/**
 * Returns the part of a URL string that matches the given RegExp.
 * @param url URL to be validated
 * @param re Regular expression to be validated against
 * @throws UrlFormatError - Thrown if url doesn't match re.
 * @returns {string} - Returns the portion of the input string that matches the RegExp.
 */
function validateUrl(url, re) {
    const match = url.match(re);
    if (match) {
        return match[0];
    }
    throw new UrlFormatError_1.default(url, re);
}
exports.validateUrl = validateUrl;
/**
 * Validates a URL and then makes a web request using Fetch API.
 * @param requestOptions Request options.
 * @param re RegExp used for validating the URL.
 * @see {@link https://esri.github.io/arcgis-rest-js/api/request/request/|ArcGIS REST JS: request}
 */
function makeValidatedRequest(requestOptions, re) {
    return __awaiter(this, void 0, void 0, function* () {
        let { endpoint } = requestOptions;
        endpoint = validateUrl(endpoint, re);
        delete requestOptions.endpoint;
        return (0, arcgis_rest_request_1.request)(endpoint, requestOptions);
    });
}
/**
 * Gets information about an LRS service
 * @param requestOptions LRS service URL. E.g., https://example.com/MyService/MapServer/exts/LRServer
 * @see {@link http://roadsandhighwayssample.esri.com/roads/api/lrsserver.html|Linear Referencing Service}
 */
function getLrsServiceInfo(requestOptions) {
    return __awaiter(this, void 0, void 0, function* () {
        return makeValidatedRequest(requestOptions, urlRe.lrsServer);
    });
}
exports.getLrsServiceInfo = getLrsServiceInfo;
/**
 * Retrieves information about all layers participating in the LRS servive.
 * @param requestOptions
 * @see {@link http://roadsandhighwayssample.esri.com/roads/api/layers.html|All Layers}
 */
function getAllLayers(requestOptions) {
    return __awaiter(this, void 0, void 0, function* () {
        return makeValidatedRequest(requestOptions, urlRe.allLayers);
    });
}
exports.getAllLayers = getAllLayers;
/**
 * Fetches information about the network layers.
 * @param requestOptions
 * @see {@link http://roadsandhighwayssample.esri.com/roads/api/networklayer.html|Network Layer}
 */
function getNetworkLayers(requestOptions) {
    return __awaiter(this, void 0, void 0, function* () {
        return makeValidatedRequest(requestOptions, urlRe.networkLayers);
    });
}
exports.getNetworkLayers = getNetworkLayers;
/**
 * Converts an array of two numbers to an input location object for
 * use with the REST API. If the input is already in the expected format,
 * it will be returned as-is.
 * @param location
 * @example
 * const locations = numbers.map(coordsToLocation);
 * @throws TypeError if the input is an array with less than two elements.
 */
function coordsToLocation(location) {
    if (Array.isArray(location)) {
        if (location.length < 2) {
            throw TypeError("Item must be an array with two or more elements.");
        }
        return {
            geometry: {
                x: location[0],
                y: location[1],
            },
        };
    }
    return location;
}
/**
 * Client for LRS Services.
 */
class LrsClient {
    /**
     * Creates a new instance of the client class.
     * @param url The URL of the LRS service.
     * @example
     * http://roadsandhighwayssample.esri.com/arcgis/rest/services/RoadsHighways/NewYork/MapServer/exts/LRServer
     */
    constructor(url) {
        this._url = validateUrl(url, urlRe.lrsServer);
    }
    /**
     * Gets the "url" property.
     */
    get url() {
        return this._url;
    }
    /**
     * Finds route measures nearest to the input locations.
     * @param layerId Layer ID integer
     * @param locations An array of objects or number arrays.
     * @param tolerance Distance around input locations to search for a route
     * @param temporalViewDate View date
     * @param inSR Spatial reference corresponding to locations parameter.
     * @param outSR Specifies the spatial reference of the output
     * @param gdbVersion GDB Version
     */
    geometryToMeasure(layerId, locations, tolerance, temporalViewDate, inSR, outSR, gdbVersion) {
        return __awaiter(this, void 0, void 0, function* () {
            const requestUrl = `${this.url}/networkLayers/${layerId}/geometryToMeasure`;
            const params = {
                locations: locations.map(coordsToLocation),
            };
            if (tolerance !== undefined) {
                params.tolerance = tolerance;
            }
            if (temporalViewDate) {
                params.temporalViewDate = temporalViewDate.getTime();
            }
            if (inSR) {
                params.inSR = inSR;
            }
            if (outSR) {
                params.outSR = outSR;
            }
            if (gdbVersion) {
                params.gdbVersion = gdbVersion;
            }
            return (yield (0, arcgis_rest_request_1.request)(requestUrl, { params }));
        });
    }
    /**
     * Returns the geometry for the input measures.
     * @param layerId Layer identifier integer
     * @param locations Objects defining measures along a route
     * @param temporalViewDate View date
     * @param outSR Spatial reference for the output geometry
     * @param gdbVersion Geodatabase Version
     */
    measureToGeometry(layerId, locations, temporalViewDate, outSR, gdbVersion) {
        return __awaiter(this, void 0, void 0, function* () {
            const requestUrl = `${this.url}/networkLayers/${layerId}/measureToGeometry`;
            const params = {
                layerId,
                locations,
            };
            if (temporalViewDate) {
                params.temporalViewDate = temporalViewDate.getTime();
            }
            if (outSR) {
                params.outSR = outSR;
            }
            if (gdbVersion) {
                params.gdbVersion = gdbVersion;
            }
            return (yield (0, arcgis_rest_request_1.request)(requestUrl, { params }));
        });
    }
}
exports.LrsClient = LrsClient;
